import { FadeLoader } from 'react-spinners';

export const LoadingNode = (): JSX.Element => (
  <FadeLoader className="!fixed !inset-1/2" color="#00C7B1" />
);
